import blogMixin from "../views/insights/blogs/mixins/blogMixin";

export default {
  mixins: [blogMixin],
  data() {
    return {
      item: {},
      category: "blogs",
    };
  },
  methods: {
    async openCaseStudy(name) {
      await this.getCaseStudy({
        $or: [
          {
            title: { $regex: name, $options: "gi" },
          },
        ],
      });
      this.handleReadMore();
    },
    getCaseStudy(filters) {
      return new Promise(async (resolve, reject) => {
        try {
          const params = {};

          params.filter = JSON.stringify({
            ...filters,
          });

          const pages = await this.$store.dispatch("cms/getPages", params);
          this.item = pages.data[0];
          resolve(pages.data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
